module.exports = {
	init: function(){
		this.products();
		this.topSlider();
	},
	products: function(){
		if($('.products_detailImg').length > 0){
			var $ele = $('.products_detailImg'),
			    $nav = $('.js_productsSliderTmb'),
			    len = $ele.find('li').index(),
			    html = '';

			//set slider nav
			$ele.find('img').each(function(index, el) {
				var src = $(this).attr('src');
				html += '<li data-index="'+ index +'"><img src="'+ src +'" alt="商品画像サムネイル"></li>';
			});
			$nav.html('<ul class="products_detailImgTmb">'+ html +'</ul>');

			//set slider
			var $li = $nav.find('li');
			$ele.on('init',function(event, slick){
				$li.eq(0).addClass('is_active');
			});
			$ele.slick({
				arrows: false,
				responsive: [{
					breakpoint: 767,
					settings: {
						arrows: true,
						prevArrow: '<span class="prev">',
						nextArrow: '<span class="next">'
					}
				}]
			});
			$ele.on('beforeChange', function(event, slick, currentSlide, nextSlide){
				$li.removeClass('is_active').eq(nextSlide).addClass('is_active');
			});
			$(document).on('click', '.js_productsSliderTmb li', function(event) {
				event.preventDefault();
				var index = $(this).data('index');
				$ele.slick('slickGoTo', parseInt(index));
			});
		}
	},
	topSlider: function() {
		if($('.js_topSlider').length > 0){
			$('.js_topSlider').slick({
				autoplay: true,
				autoplaySpeed: 5000,
				fade: true,
				speed: 500,
				arrows: false,
				dots: true,
				zIndex: 10
			});
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./src/resources/js/modules/slider.js
// module id = 3
// module chunks = 0